import { EntityWithId } from 'src/types'

export const InstrumentoLCSLHPTIFields = {
    CodPais: 'sinCodPais',
    Nombre: 'vcNombre',
    Activo: 'bitActivo',
    Orden: 'tinOrden',
    PermiteEditarNombre: 'bitPermiteEditarNombre'
} as const

export type InstrumentoLCSLHPTIDTO = EntityWithId<number> & {
    [InstrumentoLCSLHPTIFields.CodPais]: number
    [InstrumentoLCSLHPTIFields.Nombre]: string
    [InstrumentoLCSLHPTIFields.Activo]: boolean
    [InstrumentoLCSLHPTIFields.Orden]: number
    [InstrumentoLCSLHPTIFields.PermiteEditarNombre]: boolean
}

export type InstrumentoLCSLHPTIFormData = {
    [InstrumentoLCSLHPTIFields.CodPais]: number
    [InstrumentoLCSLHPTIFields.Nombre]: string
    [InstrumentoLCSLHPTIFields.PermiteEditarNombre]: boolean
}
